import React from 'react';
import { AboutSectionProps } from '@/types';

const AboutSection: React.FC<AboutSectionProps> = ({ achievements }) => {
  return (
    <section id="about" className="py-20 bg-gray-800/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Strengthening Infrastructure
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Experienced Infrastructure Engineer with expertise in cloud architecture, Kubernetes orchestration, site reliability, and cost optimization.
            Proven track record of scaling systems while reducing operational costs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {achievements.map((achievement, index) => (
            <div key={index} className="text-center p-6 bg-gray-900/50 rounded-xl border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
              <div className="text-3xl font-bold text-blue-400 mb-2">{achievement.metric}</div>
              <div className="text-gray-300">{achievement.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;